import { gsap, TweenMax, TimelineMax, TimelineLite, TweenLite, ScrollToPlugin, ScrollTrigger, CSSRulePlugin } from 'gsap/all.js';
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, TweenMax, TimelineMax, TimelineLite, TweenLite, CSSRulePlugin, );

/**
 * Up arrow annimatie
 * 
 * 1. Functie voor het animeren naar de top van de pagina met ScrollTo
 * 2. detectie van de scroll hoogte: voeg class toe
 * 
 */
export function upArrow() {

  if (!document.getElementById('back-to-top')) {return;}

  //haal de knop op uit de footer.html
  const backToTop =  document.getElementById('back-to-top');


  //click event op de knop afvangen
  backToTop.addEventListener('click', (e)=>{
    e.preventDefault();
    gsap.to(window, { duration: 1, scrollTo: 0, ease: 'power2' });
  })

  //Scroll positie

  let scrollpos = window.scrollY;


  //update on scroll:
  window.addEventListener('scroll', function() { 

    scrollpos = window.scrollY;

    //add or remove class
    if (scrollpos >= 200 ) { 
      backToTop.classList.add('show');

    }
    else { 
      backToTop.classList.remove('show');

    }
  })
}

export function setOffsetHeight() {

  var header = document.querySelectorAll('.header.fixed')[0];
  if (!header) {return;}

  //Scroll positie
  let navigationHeight = document.querySelector('.header.fixed').offsetHeight;
  // let scrollpos = window.scrollY;

  window.addEventListener('load', () => {
    
    navigationHeight = document.querySelector('.header.fixed').offsetHeight;
    //console.log(navigationHeight);
    document.documentElement.style.setProperty('--scroll-padding', navigationHeight +'px');

  });
}

export function textImageEffect1() {

  // test if the element exists by classname in the document
  if (!document.getElementsByClassName('.is-style-indrukwekkend-animated')) {return;}

    gsap.utils.toArray('.is-style-indrukwekkend-animated').forEach(function(elem) {
      // hide(elem); // assure that the element is hidden when scrolled into view, ?

      let figure= elem.querySelector('figure');
      let content = elem.querySelector('.wp-block-media-text__content');
      hide(figure); // assure that the element is hidden when scrolled into view
      hide(content); // assure that the element is hidden when scrolled into view
      
      ScrollTrigger.create({
        trigger: elem,
        start: 'top bottom-=100',
        // end: '-=200',
        // markers: true,
        onEnter: function() { animateFrom(elem) }, 
        onEnterBack: function() { animateFrom(elem, -1) },
        onLeave: function() { hide(figure), hide(content) }, // assure that the element is hidden when scrolled into view
        onLeaveBack: function() { hide(figure), hide(content) }, // assure that the element is hidden when scrolled into view

      });
    });
}

export function staggeredAnimation() {
  // test if the element exists by classname in the document
  var elementstest = document.querySelectorAll('.is-style-indrukwekkend-staggered');
  if (elementstest.length === 0) {return}  // if the element does not exist, return

  const elements = gsap.utils.toArray('.is-style-indrukwekkend-staggered .card');

  gsap.set('.is-style-indrukwekkend-staggered .card', {opacity: 0, y: 100});

  ScrollTrigger.batch('.is-style-indrukwekkend-staggered .card', {
    interval: 0.25, // time window (in seconds) for batching to occur. 
    batchMax: 3,   // maximum batch size (targets). Can be function-based for dynamic values
    onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.25}, duration: 0.5, ease: 'sine', overwrite: true}),
    // // onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
    // onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.35, overwrite: true}),
    // onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 100, overwrite: true}),
    // you can also define most normal ScrollTrigger values like start, end, etc.
    start: '50px bottom',
    end: 'top top',
  });

  ScrollTrigger.addEventListener('refreshInit', () => gsap.set(elements, {y: 0}));
}

// Helper functions in show and hide elements:

function animateFrom(elem, direction) {
  direction = direction | 1;
  
  var x = 0,
      y = direction * 100;

  if(elem.classList.contains('has-media-on-the-right')) {
    x = 100;
    y = 0;
  } else {
    x = -100;
    y = 0;
  }

  let figure= elem.querySelector('figure');

  gsap.fromTo(figure, {x: x, y: y, autoAlpha: 0}, {
    duration: 2.25, 
    x: 0,
    y: 0, 
    autoAlpha: 1, 
    ease: 'expo', 
    overwrite: 'auto',
  });

  let content = elem.querySelector('.wp-block-media-text__content');

  x = 0,
  y = direction * 100;

  gsap.fromTo(content, {x: x, y: y, autoAlpha: 0}, {
    duration: 2.25, 
    x: 0,
    y: 0, 
    autoAlpha: 1, 
    ease: 'expo', 
    overwrite: 'auto',
  });
}

function hide(elem) {
  gsap.set(elem, {autoAlpha: 0});
}

// Image compare
gsap.utils.toArray('.comparisonSection').forEach(section => {
	let tl = gsap.timeline({
			scrollTrigger: {
				trigger: section,
				start: 'center center',
        // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
				end: () => '+=' + section.offsetWidth, 
				scrub: true,
				pin: '#wp--skip-link--target',
        anticipatePin: 0,
			},
			defaults: {ease: 'none'},
		});
	tl.fromTo(section.querySelector('.afterImage'), { xPercent: 100, x: 0}, {xPercent: 0})
	.fromTo(section.querySelector('.afterImage img'), {xPercent: -100, x: 0}, {xPercent: 0}, 0);
});

// Blobs
document.querySelectorAll('[data-circle]').forEach(function(path) {
  createBlob ({
    element: path,
    numPoints: 18,
    centerX: 500,
    centerY: 500,
    minRadius: 450,
    maxRadius: 480,
    minDuration: 1,
    maxDuration: 2,
  });
});

function createBlob(options) {
  var points = [];  
  var path = options.element;
  var slice = (Math.PI * 2) / options.numPoints;
  var startAngle = random(Math.PI * 2);
  var tl = new TimelineMax({
    onUpdate: update,
  });
  for (var i = 0; i < options.numPoints; i++) {
    var angle = startAngle + i * slice;
    var duration = random(options.minDuration, options.maxDuration);
    var point = {
      x: options.centerX + Math.cos(angle) * options.minRadius,
      y: options.centerY + Math.sin(angle) * options.minRadius,
    };   
    var tween = TweenMax.to(point, duration, {
      x: options.centerX + Math.cos(angle) * options.maxRadius,
      y: options.centerY + Math.sin(angle) * options.maxRadius,
      repeat: -1,
      yoyo: true,
      //ease: Sine.easeInOut,
    });
    tl.add(tween, -random(duration));
    points.push(point);
  }
  options.tl = tl;
  options.points = points;
  function update() {
    path.setAttribute('d', cardinal(points, true, 1));
  }
  return options;
}
function cardinal(data, closed, tension) {
  if (data.length < 1) return 'M0 0';
  if (tension == null) tension = 1;
  var size = data.length - (closed ? 0 : 1);
  var path = 'M' + data[0].x + ' ' + data[0].y + ' C';
  for (var i = 0; i < size; i++) {
    var p0, p1, p2, p3;
    if (closed) {
      p0 = data[(i - 1 + size) % size];
      p1 = data[i];
      p2 = data[(i + 1) % size];
      p3 = data[(i + 2) % size];
    } else {
      p0 = i == 0 ? data[0] : data[i - 1];
      p1 = data[i];
      p2 = data[i + 1];
      p3 = i == size - 1 ? p2 : data[i + 2];
    }
    var x1 = p1.x + (p2.x - p0.x) / 6 * tension;
    var y1 = p1.y + (p2.y - p0.y) / 6 * tension;
    var x2 = p2.x - (p3.x - p1.x) / 6 * tension;
    var y2 = p2.y - (p3.y - p1.y) / 6 * tension;
    path += ' ' + x1 + ' ' + y1 + ' ' + x2 + ' ' + y2 + ' ' + p2.x + ' ' + p2.y;
  }
  return closed ? path + 'z' : path;
}
function random(min, max) {
  if (max == null) { max = min; min = 0; }
  if (min > max) { var tmp = min; min = max; max = tmp; }
  return min + (max - min) * Math.random();
}

// Text multiple lines
if ($('.columnBlob .blobdiv').length > 0) {
  $('.blobdiv a').each(function() {
      var word = $(this).text();
      var index = word.indexOf(' ');
      
      if (index === -1) {
          index = word.length;
      }

      var firstPart = word.substring(0, index);
      var secondPart = word.substring(index);

      if (secondPart) {
          $(this).html(
              '<div class="lines"><span>' + firstPart + '</span>' + secondPart + '</div>'
          );
      } else {
          $(this).html(
              '<span>' + firstPart + '</span>' + secondPart
          );
      }
  });
}

// Text multiple lines
$('.menu-top-container ul li a').each(function() {
  var word = $(this).html();
  var index = word.indexOf(' ');
  if(index == -1) {
      index = word.length;
  }
  if (word.substring(index, word.length)) {
  $(this).html('<span>' + word.substring(0, index) + '</span><div class="subtext">' + word.substring(index, word.length) + '</div>');
  } else {
    $(this).html('<span>' + word.substring(0, index) + '</span>' + word.substring(index, word.length));
  }
});

// Move blobs
if ($('.columnBlob .blobdiv').length > 0) {
  gsap.to('.columnBlob .blobdiv', {
    x: gsap.utils.random(-15, 35),
    y: gsap.utils.random(-15, 35),
    ease: 'power1.inOut',
    duration: 8, 
    repeat: -1,
    repeatRefresh: true,
  });
}

// Scroll text left-right, right-left
var _document;
gsap.registerPlugin(ScrollTrigger);
document.body.style.overflow = 'auto';
const backTextWrapper = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelectorAll('.background-text');
backTextWrapper.forEach(section => {
  const textLines = section === null || section === void 0 ? void 0 : section.querySelectorAll('p');
  textLines.forEach(function (line, index) {
    const [x, xEnd] = index % 2 ? [window.innerWidth, (line.scrollWidth - section.offsetWidth) * -1] : [line.scrollWidth * -1, 0];
    gsap.fromTo(line, {
      x,
    }, {
      x: xEnd,
      scrollTrigger: {
        trigger: section,
        scrub: 2.5,
        start: 'top bottom',
        end: 'center center',
      },
    });
  });
});

// Menu on scrolltop
$(function(){
  var lastScrollTop = 0, delta = 15;
  $(window).scroll(function(){
     var st = $(this).scrollTop();

     if (st > 350) {
      $('header').addClass( 'scrolled' );
     } else {
      $('header').removeClass( 'scrolled' );
     }

     if(Math.abs(lastScrollTop - st) <= delta)
        return;   
      if ((st > lastScrollTop) && (lastScrollTop >50)) {
          $('header').css('top','-125px');
      } else {
          $('header').css('top','0px');
      }
      lastScrollTop = st;
  });
});